import {Button, Modal} from 'antd'
import {host_getsbyOwner_api} from 'apis'
import {getId, getType} from 'apis/model/base'
import classNames from 'classnames'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import {NavigationContext} from 'modules/navigation/NavigationContext'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {IoCaretDown, IoCaretForward} from 'react-icons/io5'
import {useLocation} from 'react-router-dom'
import {useToggle} from 'react-use'
import {branch, compose, fromRenderProps, nest, pure, renderNothing,} from 'recompose'
import {ExpandablePanel} from 'views/AppLocals/custom/AdvancedFormGroup'
import EntityList from 'views/AppLocals/EntityList'
import {HostsSortBy} from 'views/AppLocals/factory/createEntitySortBy'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper from 'views/AppLocals/hooks/usePaginationHelper'
import {renderHost} from 'views/AppLocals/Host/functions/renderHost'
import HostContext, {HostProvider} from 'views/AppLocals/Host/HostContext'
import ListHeader from 'views/AppLocals/Templates/items/ListHeader'
import {NullAsDefault, renderIf} from 'views/Shared'
import WorkspaceContext from '../WorkspaceContext'
import HostsAdvancedFilter from './HostsAdvancedFilter'
import {useRouteSearchParam} from "../../../envs/_current/history";
import {DelayRender} from "../../Discovery/DelayRender";
import LoadingBlock from "../../LoadingBlock";
import {AddHostModalContent} from "../../AppLocals/Host/components/AddHostModal";

const ExpandContentWrapper = ({children}) => (
    <div className="p-4 space-y-4">{children}</div>
)

const ExpandWrapper = ({children}) => (
    <div className="border border-primary rounded-lg space-y-2">{children}</div>
)

const renderExpandHeader =
    ({count} = {}) =>
        ({title, onClick, expanded}) => {
            const IconComponent = !!expanded ? IoCaretDown : IoCaretForward
            return renderIf(
                count,
                <Translate>
                    {(t) => (
                        <div
                            className={classNames(
                                'flex items-center gap-2 p-2 text-primary bg-primary-50 cursor-pointer',
                                !!expanded ? 'rounded-t-lg' : 'rounded-lg'
                            )}
                            onClick={onClick}>
                            <IconComponent size={14}/>
                            <span className="text-sm font-medium">{t(title)}</span>
                            <span className="text-sm font-semibold">{`(${count})`}</span>
                        </div>
                    )}
                </Translate>
            )
        }

const renderCollapsedContent = (child) => (
    <div
        style={{
            visibility: 'hidden',
            maxHeight: 0,
        }}>
        {child}
    </div>
)

const GoverningOrganizationPendingList = ({refreshToken}) => {
    const [isToggle, toggle] = useToggle()

    const {container} = useContext(HostContext)

    const [id, prop] = [getId(container), getType(container)]

    const renderWrap = useCallback(
        (children, __, count) => (
            <ExpandablePanel
                onClick={toggle}
                expanded={isToggle}
                title="pending list"
                ContentWrapper={ExpandContentWrapper}
                Header={renderExpandHeader({count})}
                Wrapper={count ? ExpandWrapper : undefined}
                renderCollapsedContent={renderCollapsedContent}>
                {children}
            </ExpandablePanel>
        ),
        [isToggle]
    )

    return (
        <EntityList
            key={refreshToken}
            values={{
                request_status: -1,
            }}
            renderItem={renderHost({
                request_status: -1,
            })}
            renderWrap={renderWrap}
            RenderEntity={React.Fragment}
            apiInfo={host_getsbyOwner_api}
            query={bindQueryParams([{id}, {prop}])}
        />
    )
}

export const GoverningOrganizationList = ({
                               Header = ListHeader,
                               Wrapper = 'div',
                               filter_actions = {
                                   sortBy: 'sort-by',
                                   keyword: 'keyword',
                                   status: 'status',
                                   host_type: 'host-type',
                               },
                           }) => {
    const t = useTranslate()

    const history = useHistory()

    const location = useLocation()

    const {container} = useContext(HostContext)

    const {current} = useContext(NavigationContext)

    const [refreshKey, setRefreshKey] = useState()
    const refreshToken = useMemo(
        () =>
            JSON.stringify({
                token: _.get(location.state, 'refreshToken'),
                dependencies: [current],
                refreshKey,
            }),
        [current, refreshKey, location.state]
    )

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }
    const onRefresh = () => {
        setRefreshKey(Date.now())
    }
    const onSuccess = () => {
        setRefreshKey(Date.now())
        onCancel()
    }

    const [id, prop] = [getId(container), getType(container)]

    const status = useRouteSearchParam(filter_actions.status)

    const host_type = useRouteSearchParam(filter_actions.host_type)

    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const [pager_widget] = usePaginationHelper({
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                status,
                host_type,
            })
            onSortChange(sortBy)
        },
        pagerInfo: {
            apiInfo: host_getsbyOwner_api,
            query: bindQueryParams([
                {id},
                {
                    prop,
                },
            ]),
            renderItem: renderHost({
                request_status: 1,
            }),
            RenderEntity: React.Fragment,
        },
        withValues: (values) => ({
            ...values,
            request_status: 1,
        }),
        withKey: ({sortBy, keyword, filterBy}) =>
            [id, sortBy, keyword, JSON.stringify(filterBy), refreshToken].join('/'),
        filter_params: {
            owner_id: id,
            owner_type: prop,
        },
        query_params: filter_actions,
        dependencies: [id],
        sortHeader: t('list of co-hosting'),
        SortByWidget: HostsSortBy,
        AdvancedFilter: HostsAdvancedFilter,
    })


    const modal = useMemo(() => {
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {}
        let modal_params = {}
        switch (action.type) {
            case "ADD_HOST":
                params = {
                    ...action.value
                }
                modal_params = {
                    width: 740,
                }
                Content = AddHostModalContent
                break
            default:
                break
        }

        return (
            <Modal
                className="custom-modal"
                footer={null}
                onCancel={onCancel}
                open={action.type}
                destroyOnHidden={true}
                {...modal_params}>
                <DelayRender lazy={true}>
                    <Wrapper>
                        {({isLoading, initialValues}) => {
                            if (!!isLoading) {
                                return <LoadingBlock/>
                            }
                            return (
                                <Content
                                    {...{
                                        onCancel,
                                        item: action.value,
                                    }}
                                    {...params}
                                />
                            )
                        }}
                    </Wrapper>
                </DelayRender>
            </Modal>
        )
    }, [action])

    return (
        <Wrapper className="flex flex-col space-y-3">
            <Header
                title="co-hosts"
                extra={
                    <Button
                        type="primary"
                        className="no-border button-rounded-lg"
                        onClick={() => {
                            // history.push(gSettingModalRoutes(CustomKeys.add_host.name, {id, prop}))
                            setAction({type: "ADD_HOST", value: {id, prop}})
                        }}>
                        {t('add new')}
                    </Button>
                }
            />
            <GoverningOrganizationPendingList refreshToken={refreshToken}/>
            {pager_widget}

            {modal}
        </Wrapper>
    )
}

export default compose(
    fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
        container: organization,
    })),
    branch(({container}) => !!!getId(container), renderNothing),
    pure
)(
    nest(
        ({container, children}) => (
            <HostProvider
                container={container}
                autoRefreshKey="refreshToken">
                {children}
            </HostProvider>
        ),
        GoverningOrganizationList
    )
)
